module.exports = __webpack_public_path__ + "b2d9831a62.png";